import { render, staticRenderFns } from "./BoothTypeFullEditor.vue?vue&type=template&id=ed16e5b8"
import script from "./BoothTypeFullEditor.vue?vue&type=script&lang=ts"
export * from "./BoothTypeFullEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports